// extracted by mini-css-extract-plugin
export default {"heading_container":"Heading_heading_container__AiSFn","heading_title":"Heading_heading_title__RX1V9","code_symbol":"Heading_code_symbol__VPYLO"};